import { createSelector } from '@ngrx/store';
import { selectSequenceMetadataState } from '../index';
import { SequenceMetadataState } from '../reducers/sequence-metadata.reducer';

export const getSelectedSequenceMetadata = createSelector(
  selectSequenceMetadataState,
  (state: SequenceMetadataState) => state.sequenceMetadata
);

export const getSequenceMetadataLoading = createSelector(
  selectSequenceMetadataState,
  (state: SequenceMetadataState) => state.loading
);

export const getSequenceMetadataErrors = createSelector(
  selectSequenceMetadataState,
  (state: SequenceMetadataState) => state.errors
);
